export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/no-pic-7b4d51662eaad5c77987f7da1420c1e2.jpg";